
import jwt from '../../http/requests/auth/jwt/index.js'
import authService from '@/services/auth'
import axios from '@/axios'

import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'

export default {
  login ({commit}, payload) {
    return new Promise((resolve, reject) => {
      authService.login(payload)
        .then(response => {
          const profile = response.data.data
          if (profile.level) {
            profile.level.slug = profile.level.name.split(' ').map(item => item.toLowerCase()).join('')
          }

          commit('SET_USER_PROFILE', profile)
          commit('SET_TOKEN', `bearer ${response.data.tokens}`)

          resolve(profile)
        })
        .catch(e => reject(e))
    })
  },
  logout ({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_USER_PROFILE')
      commit('REMOVE_TOKEN')
      localStorage.removeItem('token')
      localStorage.removeItem('profile')
      resolve()
    })
  },
  register ({commit}, payload) {
    return new Promise((resolve, reject) => {
      authService.register(payload)
        .then(response => {
          const dataUser = response.data
          commit('SET_REGISTERED_USER', response.data)
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  registerMitra({commit}, payload) {
    return new Promise((resolve, reject) => {
      authService.registerMitra(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          const dataUser = response.data
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  verifyAccount ({commit}, id) {
    return new Promise((resolve, reject) => {
      authService.verify(id)
        .then(response => {
          resolve(response)
        })
        .catch(e => reject(e))
    })
  },
  forgotPassword ({commit}, email) {
    return new Promise((resolve, reject) => {
      authService.forgotPassword({email})
        .then(response => resolve(response.data))
        .catch(e => reject(e))
    })
  },
  saveProfile({commit}, payload) {
    return new Promise((resolve, reject) => {
      authService.saveProfile(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => {
        const profile = response.data
        if (profile.level) {
          profile.level.slug = profile.level.name.split(' ').map(item => item.toLowerCase()).join('')
        }
        commit('SET_USER_PROFILE', profile)
        resolve(profile)
      })
      .catch(e => reject(e))
    })
  },
  saveRegisterData({commit}, data) {
    commit('SET_REGISTERED_DATA', data)
    return Promise.resolve(data)
  },
  resetPassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      authService.resetPassword(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => resolve(response.data))
      .catch(e => reject(e))
    })
  },
  changePassword({}, payload) {
    return new Promise((resolve, reject) => {
      authService.changePassword(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => resolve(response.data))
      .catch(e => reject(e))
    })
  },
  resendEmail({}, email) {
    return new Promise((resolve, reject) => {
      authService.resendEmail({ email }, {
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => resolve(response.data))
      .catch(e => reject(e))
    })
  }
}
